
/**
 * @Description 奥乐齐免登页
 */

import { FC, useEffect } from 'react';
import { urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { microsoftAADLogin } from '@/common/api/common';
import { setCookie } from '@lhb/cache';
import { Spin } from 'antd';
import styles from './entry.module.less';
// import V2Message from '@/common/components/Others/V2Hint/V2Message';

const ALQOfExemption: FC<{}> = () => {

  const { code } = urlParams(location.search);
  useEffect(() => {
    if (!code) return;
    methods.handleLogin(code);
  }, []);

  const methods = useMethods({
    handleLogin: (code: string) => {
      const params = {
        code,
      };
      microsoftAADLogin(params).then((res) => {
        const { token, employeeId, tenantId } = res;
        // if (errCode && errMsg) {
        //   V2Message.error(errMsg);
        //   return;
        // };
        tenantId && setCookie('tenantId', tenantId);
        employeeId && setCookie('employeeId', employeeId);
        token && setCookie('flow_token', token);
        // 刷新页面
        setTimeout(() => {
          methods.handleJump();
        }, 100);
      });
    },
    handleJump: () => {
      // if (originUrl) { // 针对如果是因为访问对应页面时还未登录的场景，那就先跳到该授权页面，然后再replace到对应的页面
      //   const target = recursiveDecodeURIComponent(originUrl);
      //   window.location.replace(target || '/');
      //   return;
      // }
      window.location.replace('/');
    }
  });
  return (
    <div className={styles.container}>
      <Spin size='large' tip='登录中...'/>
    </div>
  );
};

export default ALQOfExemption;
